/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Folder_IdInputs */

const en_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folder Id`)
};

const fr_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID du dossier`)
};

const de_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner-ID`)
};

const it_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID cartella`)
};

const ru_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор папки`)
};

const es_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id. de carpeta`)
};

const zh_cn2_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹 ID`)
};

const ja_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダID`)
};

const hi_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर आईडी`)
};

const pt_pt2_folder_id = /** @type {(inputs: Folder_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da pasta`)
};

/**
* | output |
* | --- |
* | "Folder Id" |
*
* @param {Folder_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const folder_id = /** @type {((inputs?: Folder_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Folder_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_folder_id(inputs)
	if (locale === "de") return de_folder_id(inputs)
	if (locale === "it") return it_folder_id(inputs)
	if (locale === "ru") return ru_folder_id(inputs)
	if (locale === "es") return es_folder_id(inputs)
	if (locale === "zh-CN") return zh_cn2_folder_id(inputs)
	if (locale === "ja") return ja_folder_id(inputs)
	if (locale === "hi") return hi_folder_id(inputs)
	if (locale === "pt-PT") return pt_pt2_folder_id(inputs)
	return en_folder_id(inputs)
});